// All entries | Journals — the segmented control at the top of the Journal tab.
//
// Journals is a second way of looking at the same writing, not a second place it lives, so this is a
// switch between two views rather than a link into a separate section. All entries is the default,
// and choosing it always lands on the feed exactly as it was before this feature existed.

import { useNavigate } from 'react-router-dom';
import { IconBook, IconFolder } from '../components/Icons';

export function JournalModeSwitch({ mode }: { mode: 'entries' | 'journals' }) {
  const navigate = useNavigate();

  return (
    <div className="jmode" role="tablist" aria-label="How to view your writing">
      <button
        role="tab"
        aria-selected={mode === 'entries'}
        className={mode === 'entries' ? 'on' : ''}
        onClick={() => navigate('/journal')}
      >
        <IconBook /> All entries
      </button>
      <button
        role="tab"
        aria-selected={mode === 'journals'}
        className={mode === 'journals' ? 'on' : ''}
        onClick={() => navigate('/journals')}
      >
        <IconFolder /> Journals
      </button>
    </div>
  );
}
